exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-compliance-all .date-today[data-v-43aa26d2]{color:#303030;font-family:Lato;font-size:20px;font-weight:700;letter-spacing:0;line-height:28px}@media (max-width:768px){.employee-compliance-all .date-today[data-v-43aa26d2]{font-size:14px}}.employee-compliance-all .date[data-v-43aa26d2]{color:#808fa4;font-family:Open Sans;font-size:16px;letter-spacing:0;line-height:24px}@media (max-width:768px){.employee-compliance-all .date[data-v-43aa26d2]{font-size:14px}}.card[data-v-43aa26d2]{background-color:#f2f2f2}", ""]);

// exports
